import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauthenticated, object = authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const boot = async () => {
      const token = localStorage.getItem("crm_token");
      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const { data } = await http.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("crm_token");
        setUser(false);
      } finally {
        setLoading(false);
      }
    };
    boot();
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("crm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch {}
    localStorage.removeItem("crm_token");
    setUser(false);
  };

  const refreshMe = async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {}
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
